import {map, shareReplay, startWith, switchMap} from 'rxjs';
import {userWalletInfo$} from './auth';
import {connector$} from './wallet-connect';

export const walletContextTypes = {
  bind: 'bind',
  connect: 'connect',
} as const;

/**
 * 用户已绑定钱包，则不能重新连接钱包、断开钱包
 */
export const walletContextState$ = userWalletInfo$.pipe(
  map((userWalletInfo) => (userWalletInfo.address ? walletContextTypes.bind : walletContextTypes.connect)),
  switchMap((type) => (type === walletContextTypes.bind ? userWalletInfo$.pipe(map((userWalletInfo) => ({...userWalletInfo, type}))) : connector$.pipe(map(getContextWithConnector)))),
  map((context) => ({loading: false, context})),
  startWith({loading: true, context: createWalletContextDefaultData('')}),
  shareReplay(1)
);

function getContextWithConnector(connector: InferBehaviorSubject<typeof connector$>): WalletContext {
  const {address, walletType: walletName, connectorType: walletSource} = connector;
  return {
    address,
    walletName,
    walletSource,
    type: 'connect',
  };
}

function createWalletContextDefaultData(type: WalletContextTypes | '') {
  return {address: '', walletName: '', walletSource: '', type};
}

type WalletContextTypes = typeof walletContextTypes[keyof typeof walletContextTypes];
type WalletContext = ReturnType<typeof createWalletContextDefaultData>;
